import { createAsyncAction } from 'typesafe-actions';

import type { GetPersonalLoansSummary } from '@portal/api-models';

import { DemandReportingActionType } from './actionTypes';
import type { GetPersonalLoansSummaryByDemandSubAccountUuidSuccess } from './types';

export const getPersonalLoanSummaryByDemandSubAccountUuidAction =
  createAsyncAction(
    DemandReportingActionType.GET_PERSONAL_LOAN_SUMMARY_BY_DEMAND_SUBACCOUNT_UUID_REQUEST,
    DemandReportingActionType.GET_PERSONAL_LOAN_SUMMARY_BY_DEMAND_SUBACCOUNT_UUID_FAILURE,
    DemandReportingActionType.GET_PERSONAL_LOAN_SUMMARY_BY_DEMAND_SUBACCOUNT_UUID_SUCCESS
  )<
    GetPersonalLoansSummary,
    GetPersonalLoansSummaryByDemandSubAccountUuidSuccess,
    Error
  >();
